import { render } from "./SearchMenus.vue?vue&type=template&id=70487c12"
import script from "./SearchMenus.vue?vue&type=script&lang=js"
export * from "./SearchMenus.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__